import { gql } from "@apollo/client";

export const CREATE_NEWS = gql`
  mutation createAd($createAdInput: CreateAdInput!) {
    createAd(createAdInput: $createAdInput) {
      id
    }
  }
`;
